// MUI components
import { useState, useContext } from 'react'
import { useIntake } from 'hooks/useIntakeContext'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import { ScheduleMeeting } from './ScheduleMeeting'

const OnboardingSchedule = ({
  questionContainerNext,
  questionContainerBack,
  prefetchedAvailability,
}) => {
  const { intakeState } = useIntake()
  // console.log(intakeState)
  const srcURL =
    'https://team_parco.apptoto.com/?for_iframe=true&min_height=500&booking_form_only=true&name=' +
    (intakeState?.firstName === null ? '' : intakeState?.firstName) +
    ' ' +
    (intakeState?.lastName === null ? '' : intakeState?.lastName) +
    '&email=' +
    (intakeState?.email === null ? '' : intakeState?.email) +
    '&phone=' +
    (intakeState?.phone === null ? '' : intakeState?.phone)
  // console.log(srcURL)
  const portfolioReview = window.location.pathname === '/schedule'

  return (
    <Box sx={{ textAlign: 'left' }}>
      {/* <Box mb={1}>
        <Typography variant="h4" fontSize={{ xs: '20px', sm: '24px' }}>
          Set Up An Appointment
        </Typography>
      </Box> */}
      <Box component="form">
        <Grid container>
          <Grid item xs={12} mb={2}>
            {/* <div style={{ maxWidth: '1000px' }}>
              <iframe
                id="appointmentSchedule"
                src={srcURL}
                style={{
                  backgroundColor: 'transparent',
                  width: '100%',
                  border: '0px',
                  height: '700px',
                }}
                frameborder="0"
                allowTransparency="true"
              ></iframe>
            </div>
            <script src="https://cdn.apptoto.com/v5/embed.js"></script> */}
            {/* <AppointmentScheduler isOnPageForm /> */}
            <ScheduleMeeting
              isOnPageForm
              questionContainerNext={questionContainerNext}
              questionContainerBack={questionContainerBack}
              prefetchedAvailability={prefetchedAvailability}
              portfolioReview={portfolioReview}
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}

export default OnboardingSchedule
